import { css, type SerializedStyles } from '@emotion/react';

import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';

export type PhotoDateEditorStyles = {
  editButton: SerializedStyles;
};

/* Themed by the photo detail pane's own `--pd-*` variables, so the affordance reads the same on the
   takeover's dark ground as it would on a light one. The calendar it opens is MUI's own surface. */
export const DEFAULT_PHOTO_DATE_EDITOR_STYLES: PhotoDateEditorStyles = {
  editButton: css`
    label: PHOTO_DATE_EDITOR_EDIT;
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--pd-muted, ${COLORS.midtoneFaded});
    cursor: pointer;

    &:hover {
      color: var(--pd-pane-text, ${COLORS.ink});
    }
  `,
};
